import { Redirect, useLocalSearchParams } from 'expo-router';

const ViewCardScreen = () => {
    const { syncteraAccountId, cardId } = useLocalSearchParams<{
        syncteraAccountId: string;
        cardId: string;
    }>();

    return (
        <Redirect
            href={{
                pathname: '/banking/card/manage-card',
                params: { syncteraAccountId, cardId },
            }}
        />
    );
};

export default ViewCardScreen;
